(function () {
    if (window.__lxcInit) return;
    window.__lxcInit = true;

    /* colour swatch -> swap card image */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('.lxc__sw');
      if (!sw) return;
      e.preventDefault();
      var src = sw.getAttribute('data-swatch-img');
      var card = sw.closest('[data-card]');
      if (card) card.querySelectorAll('.lxc__sw').forEach(function (b) { b.classList.toggle('is-active', b === sw); });
      var img = card && card.querySelector('[data-card-img]');
      if (!src || !img) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
    });

    /* add to bag via AJAX */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-lxc-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('.lxc__btn');
      var label = form.querySelector('[data-lxc-label]');
      var old = label ? label.textContent : '';
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      if (label) label.textContent = 'Adding';

      fetch('' + ((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (item) {
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          if (label) label.textContent = 'Added to bag';
          ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { detail: { item: item }, bubbles: true }));
          });
          setTimeout(function () {
            btn.classList.remove('is-done');
            if (label) label.textContent = old;
          }, 2200);
        })
        .catch(function () {
          form.submit();
        });
    });
  })();